import { IIconProps } from './add';

export const IcoPaperSheet: React.FC<IIconProps> = ({ style, cy }) => (
  <svg
    width="17"
    height="19"
    viewBox="0 0 17 19"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    data-cy={`IcoPaperSheet${cy}`}
    style={style}
  >
    <path
      d="M8.77563 0.592773H1.77563C0.813135 0.592773 0.0256348 1.38027 0.0256348 2.34277V16.3428C0.0256348 17.3053 0.804384 18.0928 1.76688 18.0928H9.65063V11.0928H14.0256V5.84277L8.77563 0.592773ZM7.90063 6.71777V1.90527L12.7131 6.71777H7.90063ZM11.4006 17.7953V12.8428H16.3531V14.5928H14.3931L16.9744 17.174L15.7406 18.4078L13.1506 15.8265V17.7865H11.4006V17.7953Z"
      fill="white"
    />
  </svg>
);
